const accessMaintenance = {

    ASSET_LIST: { name: 'Asset', path: '/asset-list' },
    ADD_ASSET: { name: 'Add Asset', path: '/create-asset' },
    UPDATE_ASSET: { name: 'Update Asset', path: '/edit-asset' },
    DELETE_ASSET: { name: 'Delete Asset', path: '/delete-asset' },

    ASSET_SERVICE_LIST: { name: 'Asset Service', path: '/asset-service-list' },
    ADD_ASSET_SERVICE: { name: 'Add Asset Service', path: '/create-asset-service' },
    UPDATE_ASSET_SERVICE: { name: 'Update Asset Service', path: '/edit-asset-service' },
    DELETE_ASSET_SERVICE: { name: 'Delete Asset Service', path: '/delete-asset-service' },

    ASSET_INWARD_LIST: { name: 'Asset Inward', path: '/asset-inward-list' },
    ADD_ASSET_INWARD: { name: 'Add Asset Inward', path: '/create-asset-inward' },
    UPDATE_ASSET_INWARD: { name: 'Update Asset Inward', path: '/edit-asset-inward' },
    DELETE_ASSET_INWARD: { name: 'Delete Asset Inward', path: '/delete-asset-inward' },

    SCHEDULE_LIST: { name: 'Schedule', path: '/schedule-list' },
    ADD_SCHEDULE: { name: 'Add Schedule', path: '/create-schedule' },
    UPDATE_SCHEDULE: { name: 'Update Schedule', path: '/edit-schedule' },
    DELETE_SCHEDULE: { name: 'Delete Schedule', path: '/delete-schedule' },

    JOB_CARD_LIST: { name: 'Job Card', path: '/job-card-list' },
    UPDATE_JOB_CARD_STATUS: { name: 'Update Job Card Status', path: '/update-job-card-status' },

    WORK_ORDER_LIST: { name: 'Work Order', path: '/work-order-list' },
    ADD_WORK_ORDER: { name: 'Add Work Order', path: '/create-work-order' },
    UPDATE_WORK_ORDER: { name: 'Update Work Order', path: '/edit-work-order' },
    UPDATE_WORK_ORDER_STATUS: { name: 'Update Work Order Status', path: '/update-work-order-status' },
    ASSIGN_WORK_ORDER: { name: 'Assign Work Order', path: '/assign-work-order' },
    DELETE_WORK_ORDER: { name: 'Delete Work Order', path: '/delete-work-order' },

    ADMIN_MAINTENANCE: { name: 'Maintenance', path: '/maintenance' },
}

export default accessMaintenance;